export enum Area {
  PowerPlant = "Power Plant",
  NonPowerPlant = "Non Power Plant",
}

export type AreaType = {
  area?: Area | string;
};
